<template>
  <section class="yn">
    <div class="yn__bg" aria-hidden="true"></div>
    <div class="inyn">

      <div class="yn__header" v-reveal>
        <div>
          <h2 class="yn__title">{{ $t('home.newsTitle') }}</h2>
        </div>
        <router-link to="/axborot/yangiliklar" class="yn__all-link">{{ $t('common.allNews') }} ›</router-link>
      </div>

      <!-- Desktop: 3-column featured grid (needs 6 items) -->
      <div class="news-grid" v-if="news.length >= 6" ref="newsGrid">
        <div class="col-left">
          <NewsCard :item="news[0]" size="large" />
        </div>
        <div class="col-middle">
          <NewsCard v-for="item in middleNews" :key="item.id" :item="item" size="medium" />
        </div>
        <div class="col-right">
          <NewsCard v-for="item in rightNews"  :key="item.id" :item="item" size="small" />
        </div>
      </div>

      <!-- Mobile: 3 newest as stacked vertical cards -->
      <div class="news-mobile" v-if="mobileNews.length" v-reveal.stagger>
        <NewsCard v-for="item in mobileNews" :key="item.id" :item="item" size="large" />
      </div>
      <router-link v-if="mobileNews.length" to="/axborot/yangiliklar" class="yn__all-btn">{{ $t('common.allNews') }} ›</router-link>

      <p v-if="!news.length" class="yn__loading">{{ $t('common.loading') }}</p>

    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import NewsCard from './NewsCard.vue'
import { useScrollReveal, refreshScrollReveal } from '@/composables/useScrollReveal'

export default {
  name: 'YangiliklarElonlar',
  components: { NewsCard },
  setup() {
    // Featured grid columns fade up in sequence as the section scrolls in.
    const newsGrid = useScrollReveal({ animation: 'fade-up', stagger: true })
    return { newsGrid }
  },
  computed: {
    ...mapState('news', { news: state => state.items }),
    middleNews() { return this.news.slice(1, 3) },
    rightNews()  { return this.news.slice(3, 6) },
    mobileNews() { return this.news.slice(0, 3) }   // 3 newest, shown on mobile
  },
  async created() {
    await this.fetchNews()
    // The grid only renders once ≥6 items arrive; wait for that paint, then
    // recompute trigger positions against the taller document.
    await this.$nextTick()
    refreshScrollReveal()
  },
  methods: {
    ...mapActions('news', { fetchNews: 'fetch' })
  }
}
</script>

<style lang="scss">
@import '../../styles/components/02yangiliklar_va_elonlar/yangiliklar.scss';
</style>
